import { getBranchGroups } from '../../services/api/branchGroup.api';
import { GET_BRANCH_GROUP_LIST_REQUEST, GET_BRANCH_GROUP_LIST_SUCCESS, GET_BRANCH_GROUP_LIST_FAILURE } from '../types';
import { transformBranchGroups } from '../../transforms/branchGroup';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';
import { filterCaseClub } from '../../helpers/filter';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformBranchGroups([]),
		pagination: transformPagination({}),
	},

	getters: {
		onlineOptions: (state) => {
			return state.data.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});
		},
	},

	mutations: {
		[GET_BRANCH_GROUP_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_BRANCH_GROUP_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			const caseclub = data.filter((item) => filterCaseClub(item.name)); // filter case only caseclub
			state.data = transformBranchGroups(caseclub);
			state.pagination = transformPagination(meta);
		},
		[GET_BRANCH_GROUP_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getBranchGroups({ commit }, params = {}) {
			try {
				commit(GET_BRANCH_GROUP_LIST_REQUEST);
				const { data } = await getBranchGroups(params);
				commit(GET_BRANCH_GROUP_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_BRANCH_GROUP_LIST_FAILURE, error);
			}
		},
	},
};
